import { useEffect, useRef } from 'react'
import { useI18n } from '@runtime/core/i18n/i18n'
import PlayNavigationLink from '@/components/layout/playShell/PlayNavigationLink'
import styles from './PlayFailure.module.scss'

export default function PlayNotFound() {
  const { t } = useI18n()
  const heading = useRef<HTMLHeadingElement>(null)
  useEffect(() => {
    heading.current?.focus({ preventScroll: true })
  }, [])
  return (
    <section
      className={styles.failure}
      data-testid="play-not-found"
      aria-labelledby="not-found-title"
    >
      <h1 ref={heading} tabIndex={-1} id="not-found-title">
        {t('runtime.notFound.title')}
      </h1>
      <p>{t('runtime.notFound.body')}</p>
      <div className={styles.actions}>
        <PlayNavigationLink to="/home">{t('common.playNavigation.home')}</PlayNavigationLink>
      </div>
    </section>
  )
}
